module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-moen-9ae1af6e5ef00accf1e3851907e5974e.svg";